/**
 * @generated SignedSource<<782fe2c71aa5763ce57e39485961e88a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contributionsCount"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contributionsCursor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contributionsFilters"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contributionsSort"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "participativeModuleSlug"
},
v5 = [
  {
    "kind": "Variable",
    "name": "participativeModuleSlug",
    "variableName": "participativeModuleSlug"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryColor",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryContrastColor",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iconClass",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "Theme",
  "kind": "LinkedField",
  "name": "parent",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Theme",
      "kind": "LinkedField",
      "name": "parent",
      "plural": false,
      "selections": [
        (v7/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "contributionsCursor"
  },
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "contributionsFilters"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "contributionsCount"
  },
  {
    "kind": "Variable",
    "name": "sort",
    "variableName": "contributionsSort"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ContributionsDatavizSearchRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "participativeModule",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ContributionsDatavizSearch_participativeModule"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "ContributionsDatavizSearchRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "participativeModule",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "visualization",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "enableListViewOnFirstPage",
                        "storageKey": null
                      }
                    ],
                    "type": "ContributionsDataviz",
                    "abstractKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Theme",
                "kind": "LinkedField",
                "name": "themes",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Theme",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Theme",
                        "kind": "LinkedField",
                        "name": "children",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v14/*: any*/),
                "concreteType": "ContributionConnection",
                "kind": "LinkedField",
                "name": "contributions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContributionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Contribution",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "token",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Theme",
                            "kind": "LinkedField",
                            "name": "themes",
                            "plural": true,
                            "selections": [
                              (v7/*: any*/),
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isFromAdminUser",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Author",
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v9/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "avatarUrl",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "statusName",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isAdmin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "additionalViewerFields",
                                    "storageKey": null
                                  }
                                ],
                                "type": "Viewer",
                                "abstractKey": "__isViewer"
                              },
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ParticipativeModule",
                            "kind": "LinkedField",
                            "name": "participativeModule",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Theme",
                            "kind": "LinkedField",
                            "name": "theme",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/),
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Theme",
                                "kind": "LinkedField",
                                "name": "parent",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  (v10/*: any*/),
                                  (v11/*: any*/),
                                  (v9/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Theme",
                                    "kind": "LinkedField",
                                    "name": "parent",
                                    "plural": false,
                                    "selections": [
                                      (v12/*: any*/),
                                      (v10/*: any*/),
                                      (v11/*: any*/),
                                      (v9/*: any*/),
                                      (v7/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v7/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalCommentsCount",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "votesMode",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "authorizations",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "votesDisplayAuthorized",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "votesDownAuthorized",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "commentsDisplayAuthorized",
                                    "storageKey": null
                                  },
                                  (v7/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Votes",
                                "kind": "LinkedField",
                                "name": "votes",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "up",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "down",
                                    "storageKey": null
                                  },
                                  (v7/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "Reactable",
                            "abstractKey": "__isReactable"
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v14/*: any*/),
                "filters": [
                  "filters",
                  "sort"
                ],
                "handle": "connection",
                "key": "ContributionsList_contributions",
                "kind": "LinkedHandle",
                "name": "contributions"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ParticipativeModuleAuthorizations",
                "kind": "LinkedField",
                "name": "authorizations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "bookmarksCreationAuthorized",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "ParticipativeModule",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "64bebfdc7840f318a7552a4252101a79",
    "id": null,
    "metadata": {},
    "name": "ContributionsDatavizSearchRouteQuery",
    "operationKind": "query",
    "text": "query ContributionsDatavizSearchRouteQuery(\n  $participativeModuleSlug: ID!\n  $contributionsCount: Int!\n  $contributionsCursor: String\n  $contributionsFilters: ContributionsListFiltersInput\n  $contributionsSort: ContributionsSortInput\n) {\n  participativeModule(participativeModuleSlug: $participativeModuleSlug) {\n    __typename\n    ...ContributionsDatavizSearch_participativeModule\n    id\n  }\n}\n\nfragment BookmarkedFilter_participativeModule on ParticipativeModule {\n  authorizations {\n    bookmarksCreationAuthorized\n  }\n}\n\nfragment ContributionCardThemes_contribution on Contribution {\n  theme {\n    iconClass\n    primaryColor\n    primaryContrastColor\n    name\n    parent {\n      iconClass\n      primaryColor\n      primaryContrastColor\n      name\n      parent {\n        iconClass\n        primaryColor\n        primaryContrastColor\n        name\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment ContributionsDatavizFilters_participativeModule on ParticipativeModule {\n  ...ContributionsDatavizViewerFilters_participativeModule\n}\n\nfragment ContributionsDatavizListThemeContribution_contribution on Contribution {\n  slug\n  token\n  title\n  themes {\n    id\n    name\n  }\n  isFromAdminUser\n  author {\n    ...UserAvatar_user\n    ...UserAuthorName_user\n    id\n  }\n  participativeModule {\n    slug\n    id\n  }\n  ...ContributionCardThemes_contribution\n  ...ReactableMeasures_reactable\n}\n\nfragment ContributionsDatavizSearchFiltersThemes_themes on Theme {\n  id\n  name\n  primaryColor\n  primaryContrastColor\n  iconClass\n  parent {\n    id\n    parent {\n      id\n    }\n  }\n}\n\nfragment ContributionsDatavizSearchFilters_participativeModule on ParticipativeModule {\n  themes {\n    ...ContributionsDatavizSearchFiltersThemes_themes\n    children {\n      ...ContributionsDatavizSearchFiltersThemes_themes\n      children {\n        ...ContributionsDatavizSearchFiltersThemes_themes\n        id\n      }\n      id\n    }\n    id\n  }\n  ...ContributionsDatavizSearchResults_participativeModule\n  ...ContributionsDatavizFilters_participativeModule\n}\n\nfragment ContributionsDatavizSearchResults_participativeModule on ParticipativeModule {\n  id\n  contributions(first: $contributionsCount, after: $contributionsCursor, filters: $contributionsFilters, sort: $contributionsSort) {\n    totalCount\n    edges {\n      node {\n        id\n        ...ContributionsDatavizListThemeContribution_contribution\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ContributionsDatavizSearch_participativeModule on ParticipativeModule {\n  id\n  slug\n  ...ContributionsDatavizTabs_participativeModule\n  ...ContributionsDatavizSearchFilters_participativeModule\n  ...ContributionsDatavizSearchResults_participativeModule\n}\n\nfragment ContributionsDatavizTabs_participativeModule on ParticipativeModule {\n  slug\n  visualization {\n    __typename\n    ... on ContributionsDataviz {\n      enableListViewOnFirstPage\n    }\n    id\n  }\n}\n\nfragment ContributionsDatavizViewerFilters_participativeModule on ParticipativeModule {\n  ...BookmarkedFilter_participativeModule\n}\n\nfragment ReactableMeasures_reactable on Reactable {\n  __isReactable: __typename\n  totalCommentsCount\n  votesMode\n  authorizations {\n    __typename\n    votesDisplayAuthorized\n    votesDownAuthorized\n    commentsDisplayAuthorized\n    id\n  }\n  votes {\n    up\n    down\n    id\n  }\n}\n\nfragment UserAuthorName_user on Viewer {\n  __isViewer: __typename\n  name\n  statusName\n  isAdmin\n  additionalViewerFields\n}\n\nfragment UserAvatar_user on Viewer {\n  __isViewer: __typename\n  name\n  avatarUrl\n}\n"
  }
};
})();

node.hash = "0bef930519cb0bb56188553c68b51c69";

module.exports = node;
